import { render, staticRenderFns } from "./interest-calculation-create.vue?vue&type=template&id=3254b626&scoped=true"
import script from "./interest-calculation-create.vue?vue&type=script&lang=js"
export * from "./interest-calculation-create.vue?vue&type=script&lang=js"
import style0 from "./interest-calculation-create.vue?vue&type=style&index=0&id=3254b626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3254b626",
  null
  
)

export default component.exports